// import { graphql } from "react-relay";
import { graphql } from "babel-plugin-relay/macro";

export const QUERY = graphql`
	query lessonInsights_Query($submissionId: ID!) {
		Viewer {
			Learn {
				getAnswers(contentSubmissionId: $submissionId) {
					__typename
					kind
					element {
						id
						title
						elementType

						... on ClozeTextLearnElement {
							parts {
								id
								kind
								... on ClozePart {
									id
									kind
								}
								... on TextPart {
									id
									kind
									text
								}
							}
							shuffledAnswers {
								id
								text
							}
						}
						... on EnhancedTextLearnElement {
							text
						}
						... on MultipleChoiceLearnElement {
							question
							answeringType
						}
						... on OrderLearnElement {
							answeringTypeText
						}
					}

					... on ClozeTextShowAnswerElementState {
						element {
							...clozeTextLearnElement_ClozeTextLearnElementFragment
						}
						correctAnswers
						lastCheckedAnswers
						kind
					}

					... on MarkMistakesShowAnswerElementState {
						correctMistakeIndices
						lastCheckedMistakeIndices
						kind
						element {
							...markMistakesLearnElement_MarkMistakesLearnElementFragment
						}
					}

					... on MatrixShowAnswerElementState {
						kind
						correctIndices {
							index
							xIdx
							yIdx
						}
						element {
							title
							id
							elementType
						}
						lastCheckedIndices {
							yIdx
							xIdx
							index
						}
					}

					... on MultipleChoiceShowAnswerElementState {
						correctAnswerIndices
						lastCheckedAnswerIndices
						kind
						element {
							...multipleChoiceLearnElement_MultipleChoiceLearnElementFragment
						}
					}

					... on OrderShowAnswerElementState {
						correctOrder
						lastSelectedOrder
						kind
						element {
							...orderLearnElement_OrderLearnElementFragment
						}
					}
				}
			}
		}
	}
`;
export const TOGGLE_QUERY = graphql`
	query lessonInsightsActiveFeatureTogglesQuery {
		FeatureToggle {
			ActiveFeatureToggleIds
		}
	}
`;
